import * as React from "react";
import styled, { css } from "styled-components";

import Style from "@client/utils/Style";

import arrowImage from "./images/arrow";

const getLabelColor = (props: {
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
}) => {
  if (props.disabled) {
    return Style.palette.grayscale[3];
  }

  if (props.primary || props.secondary) {
    return "white";
  }

  return Style.palette.black;
};
type LabelProps = {
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
  useBold?: boolean;
  centered?: boolean;
};
const Label = styled.div<LabelProps>`
  color: ${props => getLabelColor(props)};
  margin: 0 32px 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
  margin-bottom: -1px;
  ${props => (props.useBold ? `font-weight: ${Style.fontWeights.medium};` : "")}
  ${props => (props.centered ? "text-align: center;" : "")}
`;
const getBackgroundColor = (props: {
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
}) => {
  if (props.disabled) {
    return Style.palette.grayscale[0];
  }

  if (props.secondary) {
    return Style.palette.secondaryLight;
  }

  if (props.primary) {
    return Style.palette.primary;
  }

  return "white";
};
const getArrowColor = (props: {
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
}) => {
  if (props.disabled) {
    return Style.palette.grayscale[3];
  }

  if (props.primary || props.secondary) {
    return "white";
  }

  return Style.palette.black;
};
const getWidth = (props: { width?: number; large?: boolean }) => {
  if (props.large) {
    return Style.inputSizes.large.width - 2;
  }
  if (props.width) {
    return props.width - 2;
  }
  return Style.inputSizes.regular.width - 2;
};
const borderColor = (props: {
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
  highlight?: boolean;
  selected?: boolean;
}) => {
  if (props.highlight) {
    return Style.palette.alert;
  }
  if (props.disabled) {
    return Style.palette.grayscale[0];
  }
  if (props.primary) {
    return Style.palette.primary;
  }
  if (props.secondary) {
    return Style.palette.secondaryLight;
  }
  if (props.selected) {
    return Style.palette.primaryHighlight;
  }
  return Style.palette.grayscale[3];
};
const borderHoverColor = (props: {
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
  highlight?: boolean;
}) => {
  if (props.highlight) {
    return Style.palette.alert;
  }
  if (props.disabled) {
    return Style.palette.grayscale[0];
  }
  if (props.primary) {
    return Style.palette.primary;
  }
  if (props.secondary) {
    return Style.palette.secondaryLight;
  }
  return Style.palette.primaryHighlight;
};
const backgroundHover = (props: {
  disabled?: boolean;
  secondary?: boolean;
  embedded?: boolean;
}) => {
  if (props.disabled || props.embedded) {
    return "";
  }
  if (props.secondary) {
    return Style.palette.secondaryLight;
  }
  return "";
};
type WrapperProps = {
  large?: boolean;
  embedded?: boolean;
};
const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  position: relative;
  width: ${props => getWidth(props)}px;
  height: ${props =>
    props.large
      ? Style.inputSizes.large.height - 2
      : Style.inputSizes.regular.height - 2}px;
  border: 1px solid ${(props: any) => borderColor(props)};
  border-radius: ${Style.borderRadius};
  cursor: ${(props: any) => (props.disabled ? "default" : "pointer")};
  transition: all ${Style.animations.swift};
  background: ${(props: any) => getBackgroundColor(props)};
  ${props =>
    props.embedded
      ? css`
          border: 0;
          width: calc(100% + 8px);
          margin-left: -16px;
        `
      : ""}

  #dropdown-arrow-image {
    stroke: ${(props: any) => getArrowColor(props)};
  }
  &:hover {
    background: ${(props: any) => backgroundHover(props)};
    border: 1px solid ${(props: any) => borderHoverColor(props)};
  }
`;
const Arrow = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
  display: flex;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
`;
type Props = {
  value: string;
  width?: number;
  useBold?: boolean;
  valueComponent?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  customRef?: (ref: HTMLElement | null) => void;
  innerRef?: (ref: HTMLElement | null) => void;
  arrowRef?: (ref: HTMLElement | null) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onMouseUp?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  embedded?: boolean;
  highlight?: boolean;
  primary?: boolean;
  secondary?: boolean;
  centered?: boolean;
  selected?: boolean;
};
class DropdownButton extends React.Component<Props> {
  render() {
    return (
      <Wrapper
        {...this.props}
        ref={e => {
          if (this.props.customRef) {
            this.props.customRef(e);
          } else if (this.props.innerRef) {
            this.props.innerRef(e);
          }
        }}
        onClick={e => {
          if (!this.props.disabled && this.props.onClick) this.props.onClick(e);
        }}
      >
        <Label
          {...this.props}
          onClick={() => {}}
          ref={() => {}}
          disabled={this.props.disabled}
        >
          {this.props.valueComponent || this.props.value}
        </Label>
        <Arrow
          {...this.props}
          ref={ref => {
            if (this.props.arrowRef) this.props.arrowRef(ref);
          }}
          onClick={() => {}}
          dangerouslySetInnerHTML={{ __html: arrowImage }}
        />
      </Wrapper>
    );
  }
}

export default DropdownButton;
